import { UserService } from './../../base-services/user.service';
import { ViewChild, Optional, Inject } from '@angular/core';
import { BaseEntity } from './../../base-models/base-entity';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from './../base-component';
import { BaseContainerService } from './services/base-container-service';
import { ModelDataService } from '../../base-services/model-data.service';
export class BaseContainer<T extends BaseEntity> extends BaseComponent {
    constructor(
        protected containerService: BaseContainerService<T>,
        protected activatedRoute: ActivatedRoute,
        protected userService: UserService,
        @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService
    ){
      super(activatedRoute, userService);  
    }

    //@ViewChild('fr') fr;
    //@ViewChild('tabs-cont') tabsCont;

    //AddItem(){
        //alert("Add item");
        //this.containerService.ShowUpdate();
    //}
}
